import React from "react";
import {Award, Briefcase, Grid, Key, Maximize, PieChart, PlusSquare, Sliders, Users} from "react-feather";
import {useTranslation} from "react-i18next";
import {PageHeader} from "../components/layout/PageHeader";
import {LinkBlock} from "../components/layout/LinkBlock";
import {hasAnyRole, isAdmin, isAuthenticated, isCompanyAdmin, isTraCertAdmin, permissions} from "../hooks/user";

export function HomePage() {
    const {t} = useTranslation();

    return (<>
        <PageHeader/>
        <div className={'gray-background'}>
            {/*<Alert message={<><b>{t('dashboard.reminder')}!</b> content</>} closable className={'dashboard-reminder'}/>

            <div className={'dashboard-notice'}>
                <h1>10 pending documents</h1>
                <p>some message</p>
            </div>*/}

            <ul className={'link-blocks'}>
                <LinkBlock url={'/scan'} className={'accent1-background'} title={t('menu.scan')}
                           icon={<Maximize height={60} width={60}/>}/>
                {!isAuthenticated() &&
                <LinkBlock url={'/login'} className={'accent4-background'} title={t('menu.login')}
                           icon={<Key height={60} width={60}/>}/>
                }
                {hasAnyRole(permissions.manageCertificates) &&
                <LinkBlock className={'accent2-background'} url={'/certificates/add'} title={t('menu.addCertificate')}
                           icon={<PlusSquare height={60} width={60}/>}/>
                }
                {isTraCertAdmin() &&
                <LinkBlock className={'accent3-background'} url={'/companies'} title={t('menu.companies')}
                           icon={<Briefcase height={60} width={60}/>}/>
                }
                {isCompanyAdmin() &&
                <LinkBlock className={'accent3-background'} url={'/company'} title={t('menu.company')}
                           icon={<Briefcase height={60} width={60}/>}/>
                }
                {hasAnyRole(permissions.manageCertificates) &&
                <LinkBlock className={'accent4-background'} url={'/certificates'} title={t('menu.certificates')}
                           icon={<Award height={60} width={60}/>}/>
                }
                {isAdmin() &&
                <LinkBlock className={'accent5-background'} url={'/users'} title={t('menu.users')}
                           icon={<Users height={60} width={60}/>}/>
                }
                {isTraCertAdmin() &&
                <LinkBlock className={'accent6-background'} url={'/templates'} title={t('menu.templates')}
                           icon={<Grid height={60} width={60}/>}/>
                }
                {isTraCertAdmin() &&
                <LinkBlock className={'accent6-background'} url={'/businessSectors'} title={t('menu.businessSectors')}
                           icon={<PieChart height={60} width={60}/>}/>
                }
                {isTraCertAdmin() &&
                <LinkBlock className={'admin'} url={'/billingSettings'} title={t('menu.billingSettings')}
                           icon={<Sliders height={60} width={60}/>}/>
                }
            </ul>
        </div>
    </>)
}
